/* eslint-disable @next/next/no-img-element */
import { useState, useEffect, useRef } from 'react';
import copy from 'copy-to-clipboard';


export default function CopyItem({flag, country, value, hostname }) {
  
  const [copied, setCopied] = useState(false);
  const timer = useRef(null);

  const copyAndNotify = (copyValue) => {

    copy(copyValue);
    setCopied(true);
    if (!timer.current) {
      timer.current = window.setTimeout(() => {
        setCopied(false);
        timer.current = null;
      }, 2000);
    }
  };

  useEffect(() => {
    return () => {
      timer.current && window.clearTimeout(timer.current);
    };
  }, []);

  return (
    <td
      onClick={() => copyAndNotify(value)}
      className={copied ? "py-1 text-4-5 geoip-copy notify-geo" : 'py-1 text-4-5 geoip-copy'}
      title="Kopyalama"
      style={{ wordWrap: "break-word" }}>
        <div className="d-flex"> 
          <span> {country ? country : value} {hostname && <span style={{fontSize:".75em"}}> ({hostname} ) </span>} </span>
          {flag && <div style={{ width: "2em" }}>
          <img width="100%" src={flag} alt="flags" className="pl-2" />
          </div>}
        </div>
    </td>
  )
}
